import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary';
import { logger } from './utils/logger';
import './styles/globals.css';
import './styles/marketing.css';
import './styles/responsive.css';

// Initialize logging
logger.info('Application starting', 'Main');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary
      onError={(error, errorInfo) => {
        logger.error('React Error Boundary triggered', 'Main', {
          error,
          errorInfo,
        });
      }}
    >
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
